var paypalButton = document.createElement('div');
paypalButton.id = "payPalButtonDiv";
paypalButton.style.background = "#ffc439";
paypalButton.style.width = "100%";
paypalButton.style.textAlign = "center";
paypalButton.addEventListener('click', function() {
    setTimeout(function() {
      var elements = Array.from(document.querySelectorAll('[data-class*="ymq-attrib"][data-validate="required"]'));
      var scrolledInit = false;
      var found = false;
      var customOptionsToAdd = [];
      var priceToAdd = 0.00;
      elements.forEach(function(element) {
        var possiblePriceElement = element.querySelectorAll('[data-price][checked="checked"]');
        var inputs = element.querySelectorAll('.ymq-hidden-input');
        var errorMessage = element.getElementsByClassName('ymq-error-box')[0];
        inputs.forEach(function(input) {
          if (input.getAttribute('value')  === '') {
            if (errorMessage !== null) {
              if (errorMessage.childElementCount === 0) {
                var errorItem = document.createElement('div');
                errorItem.setAttribute('class','ymq-error-item');
                errorItem.textContent = 'This is a required field.';
                errorMessage.appendChild(errorItem);

              }
               if (!scrolledInit) {
                  element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  scrolledInit = true;
                }
            }
            found = true;
          }else {
            possiblePriceElement.forEach(function(priceElement) {
              var priceFromElement = parseFloat(priceElement.getAttribute('data-price'));
              if (!isNaN(priceFromElement)) {
                priceToAdd += priceFromElement;
              }
            });
            var propertyName = input.getAttribute('name');
            var propertyValue = input.getAttribute('value');
            customOptionsToAdd.push([propertyName, propertyValue]);
          }
        });
      });
      if (!found) {
          var form = document.getElementsByClassName('installment caption-large')[0];
          var formData = new FormData(form);
          for (var i = 0; i < customOptionsToAdd.length; i++) {
            var nameValue = customOptionsToAdd[i];
            var nameOption = nameValue[0];
            var valueOption = nameValue[1];
            formData.append(nameOption, valueOption);
          }
          if (priceToAdd !== 0) {
            formData.append('properties[_YmqItemPrice]', priceToAdd);
          }
          var xhr = new XMLHttpRequest();
          xhr.open('POST', '/cart/add', true);
          xhr.setRequestHeader('Accept', 'application/json');
          xhr.onreadystatechange = function() {
            if (xhr.readyState === XMLHttpRequest.DONE) {
              if (xhr.status === 200 || xhr.status === 201) {
                window.location.href = '/cart?autoRedirect=true';
              } else {
                console.error('Fehler beim Hinzufügen zum Warenkorb:', xhr.responseText);
              }
            }
          };
          xhr.send(formData);
        }
      scrolledInit = false;
      found = false;
    }, 500);
});
var paypalImage = document.createElement('img')
paypalImage.id = "payPalImage";
paypalImage.src = "https://cdn.shopify.com/s/files/1/0770/4133/6663/files/Download.svg?v=1709144043";
paypalImage.style.width = "20%";
paypalImage.style.marginTop = "2%";
var buyButtonHolder = document.getElementsByClassName('product-form__buttons')[0];
//buyButtonHolder.appendChild(paypalButton);
//paypalButton.appendChild(paypalImage);



var currentProduct = window.location.href;
if (currentProduct.includes('tiktok-echte-follower') || currentProduct.includes('instagram-echte-follower') || currentProduct.includes('instagram-deutsche-follower')) {
var followerCount = 0;

setTimeout(function() {

var selectedCount = 100;
  
const radioButtons = document.querySelectorAll('input[type="radio"][name="Anzahl der Follower"]');

function createProfilePictureIfNotExists() {
      var imageElementToEdit = document.getElementById('accountImage');
      if (imageElementToEdit === null) {
          var profilePicture = document.createElement('img');
          var containerWithInfos = document.getElementById('containerWithInformations');
          profilePicture.id = 'accountImage';
          profilePicture.style.marginRight = '3%';
          profilePicture.style.marginTop = '0.5%';
          profilePicture.style.borderRadius =  '50%';
          profilePicture.style.width = '15%';
          containerWithInformations.insertBefore(profilePicture, containerWithInfos.firstChild);
          imageElementToEdit = document.getElementById('accountImage');
      }
}
  
function showLoadingIcon() {
    createProfilePictureIfNotExists();
    var followerElementToEditNow = document.getElementById('followerCount');
    followerElementToEditNow.textContent = '';
    var followerElementAfterToEdit = document.getElementById('followerCountAfter');
    followerElementAfterToEdit.textContent = '';
    var imageElementToEdit = document.getElementById('accountImage');
    imageElementToEdit.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 24 24'%3E%3Ccircle cx='18' cy='12' r='0' fill='%23000'%3E%3Canimate attributeName='r' begin='.67' calcMode='spline' dur='1.5s' keySplines='0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8' repeatCount='indefinite' values='0;2;0;0'/%3E%3C/circle%3E%3Ccircle cx='12' cy='12' r='0' fill='%23000'%3E%3Canimate attributeName='r' begin='.33' calcMode='spline' dur='1.5s' keySplines='0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8' repeatCount='indefinite' values='0;2;0;0'/%3E%3C/circle%3E%3Ccircle cx='6' cy='12' r='0' fill='%23000'%3E%3Canimate attributeName='r' begin='0' calcMode='spline' dur='1.5s' keySplines='0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8' repeatCount='indefinite' values='0;2;0;0'/%3E%3C/circle%3E%3C/svg%3E";
    var userNameElement = document.getElementById('userName');
    userNameElement.textContent = "Wird geladen...";
}
  
radioButtons.forEach(radioButton => {
    radioButton.addEventListener('click', function() {
        selectedCount = parseInt(radioButton.value.replace(/\D/g, ''));

         const followerElementToRead = document.getElementById('followerCount');
      const userName = document.getElementById('userName');
      if (followerElementToRead !== null && userName !== null && userName.textContent.length !== 0) {
      var followerAfter = parseInt(followerElementToRead.textContent.replace(/\D/g, ''));
      if (followerAfter !== null) {
      const followerElementToEditAfter = document.getElementById('followerCountAfter');
      var sum = selectedCount + followerAfter;
        if (!isNaN(sum)) {
          console.log(userName);
      followerElementToEditAfter.textContent = "Follower danach: " + sum + " + Bonus";
        }
      }
      }
    });
});
  
var inputUserNameBox = document.querySelector('.ymq-attrib-1');
var divForWholeInput = document.getElementById('option-box-1');
  
if (divForWholeInput != null) {
  var containerWithInformations = document.createElement('div');
  containerWithInformations.id = 'containerWithInformations';
  containerWithInformations.style.display = 'flex';
  containerWithInformations.style.alignItems = 'center';
  containerWithInformations.style.marginTop = '2%';
  containerWithInformations.style.border = '2px solid #808080';
  containerWithInformations.style.padding = '2%';
  containerWithInformations.style.width = '65%'; 
  containerWithInformations.style.boxShadow = '2px 2px 4px rgba(0, 0, 0, 0.2)'

  var containerUserNameFollowers = document.createElement('div');
  containerUserNameFollowers.id = 'containerUserNameFollowers';
  containerUserNameFollowers.style.display = 'block';

  
  var userNameText = document.createElement('span');
  userNameText.id = 'userName';
  userNameText.style.marginTop ='5%';


  containerWithInformations.appendChild(containerUserNameFollowers);
  
  containerUserNameFollowers.appendChild(userNameText);

  divForWholeInput.appendChild(containerWithInformations);

  var followerCountText = document.createElement('a');
  followerCountText.id = 'followerCount';
  followerCountText.style.display = 'block';
  followerCountText.textContent = `Aktuelle Follower: ${followerCount} (Bitte Benutzername angeben)`;
  followerCountText.style.fontSize = '10px';
  followerCountText.style.fontWeight = 'bold';

  var followerCountAfterText = document.createElement('a');
  followerCountAfterText.id = 'followerCountAfter';
  followerCountAfterText.style.display = 'block';
  followerCountAfterText.textContent = ``;
  followerCountAfterText.style.fontSize = '10px';
  followerCountAfterText.style.fontWeight = 'bold';
  followerCountAfterText.style.color =  'green';
  
  containerUserNameFollowers.appendChild(followerCountText);
  containerUserNameFollowers.appendChild(followerCountAfterText);
}

if (currentProduct.includes('tiktok-echte-follower')) {
  
let debounceTimer;

inputUserNameBox.addEventListener('input', function(event) {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(function() {
    const userInput = inputUserNameBox.value.trim();
    if (userInput.length >= 1) {
      showLoadingIcon();
      fetchData(userInput);
    }
  }, 1500);
});

  function fetchData(userInput) {
  const requestHeader = {
    method: 'GET',
    headers: {
      'Authorization': 'Basic THVjYTpLYXVmdEJlaU1pcjY5',
      'Referrer-Policy': 'no-referrer'
    }
  };

  var userNameWithOutAdd = userInput.replace(/@/g, '');
  const url = `http://45.93.250.121/tiktok/fetchFollowerCount.php?userName=${userNameWithOutAdd}`;

  fetch(url, requestHeader)
    .then(response => {
      if (response.ok) {
        return response.json(); 
      } else {
        throw new Error('Fehler bei Anfrage an Webserver.');
      }
    })
    .then(responseJson => {
      
      var followerCountFetched = responseJson.tiktok.user.follower_count;
      var profilePictureFetch = responseJson.tiktok.user.avatar_168x168.url_list[0];
      createProfilePictureIfNotExists();
      var imageElementToEdit = document.getElementById('accountImage');
      imageElementToEdit.src = profilePictureFetch;
      
      const userNameToEdit = document.getElementById('userName');
      userNameToEdit.textContent = userInput;

      followerCount = followerCountFetched;
      const followerElementToEdit = document.getElementById('followerCount');
      followerElementToEdit.style.marginTop = '-4%';
      followerElementToEdit.textContent = `Aktuelle Follower: ${followerCount} `;
      
      const followerElementAfterToEdit = document.getElementById('followerCountAfter');
      followerElementAfterToEdit.style.marginTop = '-4%';
      const followerNumber = parseInt(followerCount);
      const sum = followerNumber + selectedCount;
      followerElementAfterToEdit.textContent = `Follower danach: ${sum} + Bonus`;
    })
    .catch(error => {
      createProfilePictureIfNotExists();
      var imageElementToEdit = document.getElementById('accountImage');
      imageElementToEdit.src = 'https://45.93.250.121/error.png';
      const followerElementToEdit = document.getElementById('followerCount');
      followerElementToEdit.textContent = '';

      const followerElementAfterToEdit = document.getElementById('followerCountAfter');
      followerElementAfterToEdit.textContent = '';

      const userNameToEdit = document.getElementById('userName');
      userNameToEdit.textContent = 'Ungültiger Benutzername';
    });
  }
  }  

if (currentProduct.includes('instagram-echte-follower') || currentProduct.includes('instagram-deutsche-follower')) {
  
let debounceTimer;

inputUserNameBox.addEventListener('input', function(event) {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(function() {
    const userInput = inputUserNameBox.value.trim();
    if (userInput.length >= 3) {
      showLoadingIcon();
      fetchData(userInput);
    }
  }, 1500);
});

  function fetchData(userInput) {
  const requestHeader = {
    method: 'GET',
    headers: {
      'Authorization': 'Basic THVjYTpLYXVmdEJlaU1pcjY5',
      'Referrer-Policy': 'no-referrer'
    }
  };
  var userNameWithOutAdd = userInput.replace(/@/g, '');
  const url = `http://45.93.250.121/instagram/fetchFollowerCount.php?userName=${userNameWithOutAdd}`;

  fetch(url, requestHeader)
    .then(response => {
      if (response.ok) {
        return response.json(); 
      } else {
        throw new Error('Fehler bei Anfrage an Webserver.');
      }
    })
    .then(responseJson => {
      if (responseJson.length > 0 && responseJson[0].error_code === "IgExactUserNotFoundError") {
      createProfilePictureIfNotExists();
      var imageElementToEdit = document.getElementById('accountImage');
      imageElementToEdit.src = 'https://45.93.250.121/error.png';
      const followerElementToEdit = document.getElementById('followerCount');
      followerElementToEdit.textContent = '';
      const followerElementAfterToEdit = document.getElementById('followerCountAfter');
      followerElementAfterToEdit.textContent = '';
      const userNameToEdit = document.getElementById('userName');
      userNameToEdit.textContent = 'Ungültiger Benutzername';
      }else {
      var followerCountFetched = responseJson[0].follower_count;
      var profilePictureFetch = responseJson[0].profile_pic_url;
      createProfilePictureIfNotExists();
      var imageElementToEdit = document.getElementById('accountImage');
      imageElementToEdit.src = "https://45.93.250.121/instagram/getImage.php?url=" + profilePictureFetch;
      
      const userNameToEdit = document.getElementById('userName');
      userNameToEdit.textContent = userInput;

      followerCount = followerCountFetched;
      const followerElementToEdit = document.getElementById('followerCount');
      followerElementToEdit.style.marginTop = '-4%';
      followerElementToEdit.textContent = `Aktuelle Follower: ${followerCount}`;

      const followerElementAfterToEdit = document.getElementById('followerCountAfter');
      followerElementAfterToEdit.style.marginTop = '-4%';
      const followerNumber = parseInt(followerCount);
      const sum = followerNumber + selectedCount;
      followerElementAfterToEdit.textContent = `Follower danach: ${sum} + Bonus`;
      }
    })
    .catch(error => {
      createProfilePictureIfNotExists();
      var imageElementToEdit = document.getElementById('accountImage');
      imageElementToEdit.src = 'https://45.93.250.121/error.png';
      const followerElementToEdit = document.getElementById('followerCount');
      followerElementToEdit.textContent = '';
      const followerElementAfterToEdit = document.getElementById('followerCountAfter');
      followerElementAfterToEdit.textContent = '';
      const userNameToEdit = document.getElementById('userName');
      userNameToEdit.textContent = 'Ungültiger Benutzername';
    });
  }
  }  
}, 100);
}


if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}
